import Swiper from "swiper";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

const latestBlogPosts = document.querySelector(".latest-blog-posts");

if (latestBlogPosts) {
  const container = latestBlogPosts.querySelector(".swiper");
  new Swiper(container, {
    modules: [A11y, Autoplay, Pagination],
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    autoHeight: true,
    slidesPerView: 1,
    speed: 1000,
    pagination: {
      el: latestBlogPosts.querySelector(".slider-pagination"),
      clickable: true
    },
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
}
